import React from "react";

// Grafiki metod płatności: /public/img/pay/*.svg — żeby podmienić na oficjalne logotypy,
// wystarczy wgrać pliki o tych samych nazwach (visa.svg, mastercard.svg, blik.svg, p24.svg, transfer.svg).
export const PAYMENT_OPTIONS = [
  {
    id: "card",
    title: "Karta płatnicza",
    subtitle: "Visa, Mastercard — natychmiast",
    logos: ["/img/pay/visa.svg", "/img/pay/mastercard.svg"],
    via: "stripe",
    accent: "cyan",
    buttonLabel: "Zapłać kartą",
    note: "Płatność kartą Visa / Mastercard obsługuje bezpieczny system Stripe. Pliki otrzymasz natychmiast po opłaceniu.",
  },
  {
    id: "blik",
    title: "BLIK",
    subtitle: "Kod z aplikacji Twojego banku",
    logos: ["/img/pay/blik.svg"],
    via: "stripe",
    accent: "fuchsia",
    buttonLabel: "Zapłać BLIKIEM",
    note: "Płatność BLIKIEM obsługuje bezpieczny system Stripe. Pliki otrzymasz natychmiast po potwierdzeniu w aplikacji banku.",
  },
  {
    id: "p24",
    title: "Przelew elektroniczny",
    subtitle: "Przelewy24 — szybki przelew online",
    logos: ["/img/pay/p24.svg"],
    via: "stripe",
    accent: "rose",
    buttonLabel: "Zapłać przelewem online",
    note: "Szybki przelew online przez Przelewy24 obsługuje bezpieczny system Stripe. Pliki otrzymasz zaraz po zaksięgowaniu płatności.",
  },
  {
    id: "transfer",
    title: "Przelew bankowy",
    subtitle: "Tradycyjny przelew na nasze konto",
    logos: ["/img/pay/transfer.svg"],
    via: "manual",
    accent: "teal",
    buttonLabel: "Złóż zamówienie z przelewem",
    note: "Po zaksięgowaniu przelewu wyślemy produkt e-mailem — natychmiast po otrzymaniu płatności na nasze konto.",
  },
];

export const ACCENTS = {
  cyan: "border-cyan-400/70 bg-cyan-500/10 shadow-[0_8px_24px_-8px_rgba(6,182,212,.5)]",
  fuchsia: "border-fuchsia-400/70 bg-fuchsia-500/10 shadow-[0_8px_24px_-8px_rgba(217,70,239,.45)]",
  rose: "border-rose-400/70 bg-rose-500/10 shadow-[0_8px_24px_-8px_rgba(244,63,94,.45)]",
  teal: "border-teal-400/70 bg-teal-500/10 shadow-[0_8px_24px_-8px_rgba(45,212,191,.5)]",
};

// Mały pasek „Akceptujemy" — pod sumą w koszyku
export function PaymentLogoStrip({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`} data-testid="payment-logo-strip" aria-label="Akceptowane formy płatności">
      {PAYMENT_OPTIONS.flatMap((o) => o.logos.map((src) => ({ src, alt: o.title, key: o.id + src }))).map((l) => (
        <img key={l.key} src={l.src} alt={l.alt} loading="lazy" className="h-7 w-auto rounded-md shadow-md ring-1 ring-white/10" />
      ))}
    </div>
  );
}
